import React from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import {
  getCertificates,
  getIHMFullManual,
  getOtherTask,
  getPendingTask,
  getShipDetail,
  getSixMonthReviews,
} from "../Actions/ShipViewAPI";
import axios from "axios";
import API from "../helpers/api";

class ShipDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    let shipId = parseInt(match.params.shipId);
    if (shipId) {
      dispatch(getShipDetail(shipId));
      dispatch(getPendingTask(shipId, 1));
      dispatch(getOtherTask(shipId, 1));
      dispatch(getIHMFullManual(shipId));
      dispatch(getCertificates(shipId));
      dispatch(getSixMonthReviews(shipId));
    } else {
      this.getShipDetail();
    }
  }

  getShipDetail = () => {
    const { dispatch } = this.props;
    let user = JSON.parse(localStorage.getItem("currentUser"));
    if (user.email) {
      let url = `${API.ShipDetail}?Mail=${user.email}`;
      axios
        .get(url)
        .then((response) => {
          localStorage.setItem("shipId", response.data.shipId);
          dispatch({
            type: "TEFormApplicable",
            data: response.data.isTeFromApplicable,
          });
          // localStorage.setItem("TEFormApplicable", response.data.isTeFromApplicable);
          dispatch(getPendingTask(response.data.shipId, 1));
          dispatch(getOtherTask(response.data.shipId, 1));
          dispatch(getIHMFullManual(response.data.shipId));
          dispatch(getCertificates(response.data.shipId));
          dispatch({
            type: "getShipDetailSuccess",
            data: response.data,
          });
          dispatch({ type: "StaffShipId", data: response.data.shipId });
        })
        .catch((error) => {
          dispatch({
            type: "getShipDetailFailure",
            error: "ERROR",
          });
        });
    }
  };

  hideSidePanel = () => {
    let user = localStorage.getItem("UserRoles");
    if (user === "admin") {
      this.props.history.push(`/Home/MMPlDashboard`);
    }
    if (user === "mmpl") {
      this.props.history.goBack();
    }
    if (user === "client") {
      this.props.history.push(`/Home/ClientDashboard`);
    }
    if (user === "consultant") {
      this.props.history.replace(
        `/Home/SpecialAccess/ships/${this.props.shipDetail.clientId}`
      );
    }
  };

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   const { dispatch } = nextProps;
  // }

  render() {
    const { shipDetail, ShowStaffPendingTaskPanel } = this.props;
    let user = localStorage.getItem("UserRoles");

    return (
      <div className="full-height pt-3">
        {user === "admin" ||
        user === "mmpl" ||
        user === "client" ||
        user === "consultant" ? (
          <button
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue d-flex align-items-center justify-content-center gap-2"
            onClick={() => this.hideSidePanel()}
          >
            <span
              className="fs-5 "
              style={{ marginTop: "-2px", marginRight: "2px" }}
            >
              &larr;
            </span>
            <span>Back</span>
          </button>
        ) : (
          ""
        )}
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="py-2">
                <div className="resource-list-auth-date">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row my-2 mx-3">
                        <div
                          className={
                            ShowStaffPendingTaskPanel
                              ? "col-sm-6 mb-1"
                              : "col-sm-5 col-md-5"
                          }
                        >
                          <span>
                            <strong>Ship Name : </strong>
                            <span className="lato">
                              {shipDetail ? shipDetail.shipName : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            ShowStaffPendingTaskPanel
                              ? "col-sm-6 mb-1"
                              : "col-sm-2 col-md-2"
                          }
                        >
                          <span>
                            <strong>IMO No : </strong>
                            <span className="lato">
                              {shipDetail ? shipDetail.imoNo : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            ShowStaffPendingTaskPanel
                              ? "col-sm-6"
                              : "col-sm-2 col-md-2"
                          }
                        >
                          <span>
                            <strong>Class : </strong>
                            <span className="lato">
                              {shipDetail ? shipDetail.className : ""}
                            </span>
                          </span>
                        </div>
                        <div
                          className={
                            ShowStaffPendingTaskPanel
                              ? "col-sm-6"
                              : "col-sm-3 col-md-3"
                          }
                        >
                          <span>
                            <strong>Flag : </strong>
                            <span className="lato">
                              {shipDetail ? shipDetail.flagName : ""}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    //BY BALU MOORTHI
    editPOView: state.SidePanReducer.EditPOView || false,
    ShowStaffPendingTaskPanel:
      state.SidePanReducer.ShowStaffPendingTaskPanel || false,
    shipDetail: state.ShipViewReducer.ShipDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipDetail);
